var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaretUp(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 9,
    viewBox: "0 0 14 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 2L7.70711 1.29289L7 0.585786L6.29289 1.29289L7 2ZM6.29289 2.70711L12.2929 8.70711L13.7071 7.29289L7.70711 1.29289L6.29289 2.70711ZM1.70711 8.70711L7.70711 2.70711L6.29289 1.29289L0.292893 7.29289L1.70711 8.70711Z",
    fill: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretUp);
export default __webpack_public_path__ + "static/media/caret-up.466848a9.svg";
export { ForwardRef as ReactComponent };